const state = {
    isLoading: false,
    bidError: {
        status: false,
        message: ''
    },
    currentBid: {
        id: '',
        status:  '',
        amount_yen:  null,
        amount_usd: null,
        lot_id: '',
        group: {}
    }
}

const getters = {
    getBidErrorStatus: (state) => {
        return state.bidError.status
    },
    getBidErrorMessage: (state) => {
        return state.bidError.message
    },
    getCurrentBidId: (state) => {
        return state.currentBid.id
    },
    getCurrentBid: (state) => {
        return state.currentBid
    },
    getPlaceBidLoadingStatus: (state) => {
        return state.isLoading
    },
    getCurrentBidStatus: (state) => {
        return state.currentBid.status
    },
    getCurrentBidAmountYen: (state) => {
        return state.currentBid.amount_yen
    },
    getCurrentBidAmountUsd: (state) => {
        return state.currentBid.amount_usd
    },
    getCurrentBidLotId: (state) => {
        return state.currentBid.lot_id
    },
    getCurrentBidGroupId: (state) => {
        return state.currentBid.group_id
    },
    getCurrentBidGroupMaxWins: (state) => {
        return state.currentBid.max_wins
    },
    getCurrentBidGroupRemarks: (state) => {
        return state.currentBid.remarks
    }
 }

const mutations = {
    setBidError: (state, newValue) => {
        state.bidError[newValue.field] = newValue.value
    },
    setCurrentBidId: (state, newId) => {
        state.currentBid.id = newId
    },
    setPlaceBidLoadingStatus: (state, newStatus) => {
        state.isLoading = newStatus
    },
    setCurrentBid: (state, newStatus) => {
        state.currentBid = newStatus
    },
    setBidLoadingStatus: (state, newStatus) => {
        state.isLoading = newStatus
    },
    setCurrentBidStatus: (state, newBidStatus) => {
        state.currentBid.status = newBidStatus
    },
    setCurrentBidAmountYen: (state, newAmountYen) => {
        state.currentBid.amount_yen = newAmountYen
    },
    setCurrentBidAmountUsd: (state, newAmountUsd) => {
        state.currentBid.amount_usd = newAmountUsd
    },
    setCurrentBidLotId: (state, newLotId) => {
        state.currentBid.lot_id = newLotId
    },
    setCurrentBidGroup: (state, newGroup) => {
        state.currentBid.group = newGroup
    }
}

const actions = {
    changeBidError: ({commit}, newValue) => {
        commit('setBidError', newValue)
    },
    changeCurrentBidId: ({ commit }, newId) =>  {
        commit('setCurrentBidId', newId)
    },
    changePlaceBidLoadingStatus: ({ commit }, newStatus) =>  {
        commit('setPlaceBidLoadingStatus', newStatus)
    },
    changeCurrentBid: ({ commit }, newBid) => {
        commit('setCurrentBid', newBid)
    },
    changeCurrentBidStatus: ({ commit }, newBidStatus) => {
        commit('setCurrentBidStatus', newBidStatus)
    },
    changeCurrentBidAmountYen: ({ commit }, newAmountYen) => {
        commit('setCurrentBidAmountYen', newAmountYen)
    },
    changeCurrentBidAmountUsd: ({ commit }, AmountUsd) => {
        commit('setCurrentBidAmountUsd', AmountUsd)
    },
    changeCurrentBidLotId: ({ commit }, newLotId) => {
        commit('setCurrentBidLotId', newLotId)
    },
    changeCurrentBidGroup: ({ commit }, newGroup) => {
        commit('setCurrentBidGroup', newGroup)
    }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/placeBid.js